<template>
    <b-modal :title="this.$route.name" no-close-on-backdrop hide-footer size="xl" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="UpdateHolding">
            <div>
                <div v-if="$user.type==1" class="form-group row">
                    <label for="bn_name" class="col-sm-2 col-form-label">বাংলায় নাম লিখুন</label>
                    <div class="col-sm-3">
                        <input name="bn_name" v-validate="'required'" v-model="editholdingForm.bn_name" class="form-control"  >
                        <!--                        <p  v-show="errors.has('bn_name')" style="color:red">* {{ errors.first('bn_name') }}</p>-->
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="en_name" class="col-sm-2 col-form-label">ইংরেজিতে নাম লিখুন</label>
                    <div class="col-sm-3">
                        <input name="en_name"  v-validate="'required'" v-model="editholdingForm.en_name" class="form-control"  >
                        <!--                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>-->
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="home_name" class="col-sm-2 col-form-label">বাসার নাম লিখুন </label>
                    <div class="col-sm-3">
                        <input name="home_name"  v-validate="'required'" v-model="editholdingForm.home_name" class="form-control"  >
                        <!--                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>-->
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="address" class="col-sm-2 col-form-label"> অ্যাড্রেস </label>
                    <div class="col-sm-3">
                        <input name="address"  v-validate="'required'" v-model="editholdingForm.address" class="form-control"  >
                        <!--                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>-->
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="owner_name" class="col-sm-2 col-form-label">মালিকের নাম </label>
                    <div class="col-sm-3">
                        <input name="owner_name"  v-validate="'required'" v-model="editholdingForm.owner_name" class="form-control"  >
                        <!--                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>-->
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="word_no" class="col-sm-2 col-form-label ">Select Ward No</label>
                    <div class="col-sm-3">
                        <div class="input-group">
                            <select  name="word_no" v-model="editholdingForm.word_no"  class="form-control" >
                                <option v-for="ward in wards" :value="ward.id" >{{ ward.ward_name_bng}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="avatar" class="col-sm-2 col-form-label">ইমেজ আপলোড </label>
                    <div class="col-sm-3">
                        <input name="avatar" type="file" @change="onAvatarChange"  v-validate="'required'"  class="form-control"  >
                        <!--                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>-->
                    </div>
                </div>
                <div v-if="$user.type==1" class="form-group row">
                    <label for="approve" class="col-sm-2 col-form-label ">Select Status</label>
                    <b-form-group>
                        <div class="col-sm-3">
                            <b-form-radio v-model="selected"   name="status" value="1">Approved</b-form-radio>
                        </div>
                        <div class="col-sm-3">
                            <b-form-radio  v-model="selected"  name="status" value="0">Not Approved</b-form-radio>
                        </div>
                    </b-form-group>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <input v-if="!addLoader" type="submit" value="Update" class="btn btn-primary pull-right"/>
                        <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                        <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    import axios from 'axios'
    export default {
        data(){
            return{
                largeModal:false,
                addLoader: false,
                index:'',
                selected:'',
                editholdingForm:{
                    id:'',
                    bn_name:'',
                    en_name:'',
                    word_no:'',
                    home_name:'',
                    address:'',
                    owner_name:'',
                    status:'',
                    avatar:''
                }
            }
        },

        computed:{
            ...mapGetters(['wards','modal'])
        },
        mounted(){
            this.wardLists()
        },
        methods:{
            onAvatarChange(e) {
                var fileReader = new FileReader()
                fileReader.readAsDataURL(e.target.files[0])
                fileReader.onload = e => {
                    this.editholdingForm.avatar = e.target.result
                }
                this.check = false
                // this.url = URL.createObjectURL(e.target.files[0])
            },
            openModal(holding,index){
                this.largeModal = true
                this.index = index
                this.selected = holding.status
                this.editholdingForm.id = holding.id
                this.editholdingForm.bn_name = holding.bn_name
                this.editholdingForm.en_name = holding.en_name
                this.editholdingForm.word_no = holding.word_no
                this.editholdingForm.home_name = holding.home_name
                this.editholdingForm.address = holding.address
                this.editholdingForm.owner_name = holding.owner_name
                this.editholdingForm.status = holding.status
            },
            close(){
                this.largeModal = false
            },
            UpdateHolding(){
                this.addLoader = true
                this.editholdingForm.status = this.selected
                var editForm = this.editholdingForm
                var index = this.index
                this.$store.dispatch('UPDATE_HOLDING',{editForm,index})
                    .then(v=>{
                        this.addLoader = false
                        this.largeModal =false
                    })
                    .catch(error=>{
                        alert()
                        console.log(error)
                    })
            },
            wardLists(){
                this.$store.dispatch('WARD_LIST')
            }
        }

    }
</script>
<style>

</style>